import { uuid } from 'vue-uuid';
import { mapGetters } from 'vuex';
import { GET_ENUM_BY_NAME } from '../../modules/enums/store/types';
import socialMedia from '../helpers/socialMedia';

export default {
  data() {
    return {
      requestTimout: null,
    };
  },
  computed: {
    ...mapGetters([GET_ENUM_BY_NAME]),
  },
  methods: {
    getUUID(name) {
      const NAMESPACE = '65f9af5d-f23f-4065-ac85-da725569fdcd';
      return uuid.v5(name, NAMESPACE);
    },
    getEnumByTitle(title) {
      let result = [];
      if (this.getEnumByName(title))
        result = this.getEnumByName(title)['enumValues'];
      return result;
    },
    multiselectLabel(object) {
      return ` ${object.value}`;
    },
    pruneProperties(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === '') obj[key] = null;
        if (obj[key] === []) obj[key] = null;
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.pruneProperties(obj[key]);
        }
      });
    },
    jalaliDate(date) {
      return new Date(date).toLocaleDateString('fa-IR');
    },
    getFaDate() {
      return new Date()
        .toLocaleDateString('fa-IR')
        .replace(/([۰-۹])/g, (token) =>
          String.fromCharCode(token.charCodeAt(0) - 1728)
        )
        .split('/')
        .join('-');
    },
    getDate() {
      return new Date().toISOString().slice(0, 10);
    },
    addMonthToDate(numOfMonth) {
      let parse = parseInt(numOfMonth);
      if (parse == NaN) numOfMonth = 0;
      let date = new Date();
      date.setMonth(date.getMonth() + numOfMonth);
      return date.toISOString().slice(0, 10);
    },
    subMonthOfDate(numOfMonth) {
      let parse = parseInt(numOfMonth);
      if (parse == NaN) numOfMonth = 0;
      let date = new Date();
      date.setMonth(date.getMonth() - numOfMonth);
      return date.toISOString().slice(0, 10);
    },
    addYearsToDate(numOfYears) {
      let parse = parseInt(numOfYears);
      if (parse == NaN) numOfYears = 0;
      let date = new Date();
      date.setFullYear(date.getFullYear() + numOfYears);
      return date.toISOString().slice(0, 10);
    },
    subYearsOfDate(numOfYears) {
      let parse = parseInt(numOfYears);
      if (parse == NaN) numOfYears = 0;
      let date = new Date();
      date.setFullYear(date.getFullYear() - numOfYears);
      return date.toISOString().slice(0, 10);
    },

    moneyFormat(int) {
      return !isNaN(parseFloat(int)) && isFinite(int)
        ? Intl.NumberFormat('ir-fa').format(parseFloat(int))
        : '';
    },

    isPositiveNumber(event) {
      let char = String.fromCharCode(event.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else event.preventDefault();
    },

    socialMediaDisplayName(title) {
      if (title) {
        return socialMedia[title] ?? title
      }
      return title
    }
  },
};
